export default __webpack_public_path__ + "static/media/femaleAvatar.3b20507c.jpg";